import { FC, useContext, useState } from "react";
import NotificationDispatch, {
  showErrorNotification,
  showSuccessNotification,
} from "../../context/notificationContext";
import { useI18n } from "../../hooks/useTranslations";
import { useSuppliersApi } from "../../http/suppliers/api";
import { UpsertSupplier } from "../../http/suppliers/types";
import SvgAdd from "../icons/Add";
import Button from "../ui/Button";
import ModalDialog from "../ui/ModalDialog";
import SupplierForm, { SupplierFormBody } from "./SupplierForm";

const CreateSupplierButton: FC = () => {
  const i18n = useI18n();
  const [show, setShow] = useState(false);
  const dispatch = useContext(NotificationDispatch);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const suppliersApi = useSuppliersApi();

  const onSubmit = async (formData: SupplierFormBody) => {
    const body: UpsertSupplier = {
      name: formData.name,
      address: formData.address,
      email: formData.email,
      phoneNumber: formData.phoneNumber,
    };

    setIsSubmitting(true);
    try {
      await suppliersApi.insertAdminSupplier(body);
      dispatch(showSuccessNotification(i18n.t));
      setShow(false);
    } catch (error) {
      dispatch(showErrorNotification(i18n, error));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <Button buttonProps={{ onClick: () => setShow(true) }} glyph={SvgAdd} />
      {!!show && (
        <ModalDialog onClose={() => setShow(false)} title={i18n.t.suppliers.new}>
          <SupplierForm isDisabled={isSubmitting} onSubmit={onSubmit} />
        </ModalDialog>
      )}
    </>
  );
};

export default CreateSupplierButton;
